module.exports = __webpack_public_path__ + "img/bookp.cd7fa50a.png";